export const enum Permission {
  ReadUsers = 'users:read',
  WriteUsers = 'users:write',
  ReadPaymentFiles = 'payment_files:read',
  WritePaymentFiles = 'payment_files:write',
  ReadCheckRegisters = 'check_registers:read',
  WriteCheckRegisters = 'check_registers:write',
  ReadScheduler = 'scheduler:read',
  WriteScheduler = 'scheduler:write',
  ReadLocations = 'locations:read',
  WriteLocations = 'locations:write',
  ReadHolidays = 'holidays:read',
  WriteHolidays = 'holidays:write',
  ReadGroups = 'groups:read',
  WriteGroups = 'groups:write',
  ReadAccountsPayable = 'accounts_payable:read',
  WriteAccountsPayable = 'accounts_payable:write',
  ReadAccountsReceivable = 'accounts_receivable:read',
  WriteAccountsReceivable = 'accounts_receivable:write',
  ReadSummary = 'summary:read',
  WriteSummary = 'summary:write',
  ReadStatistics = 'statistics:read',
  WriteStatistics = 'statistics:write',
  ReadNotificationsSettings = 'notifications_settings:read',
  WriteNotificationsSettings = 'notifications_settings:write',
  ReadNotifications = 'notifications:read',
  WriteNotifications = 'notifications:write',
  ReadClaims = 'claims:read',
  WriteClaims = 'claims:write',
  DeleteClaims = 'claims:delete'
}
